var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "insRegistrationView" }, [
    _c(
      "div",
      { staticClass: "search_container" },
      [
        _c(
          "el-form",
          {
            ref: "form",
            staticClass: "searchBox",
            attrs: { size: "mini", inline: true, model: _vm.orgData },
          },
          [
            _c(
              "el-form-item",
              { attrs: { label: "名称" } },
              [
                _c("el-input", {
                  attrs: { clearable: "", placeholder: "请输入机构名称" },
                  on: {
                    change: function ($event) {
                      return _vm.getInsRegistrationView(1)
                    },
                  },
                  model: {
                    value: _vm.orgData.name,
                    callback: function ($$v) {
                      _vm.$set(_vm.orgData, "name", $$v)
                    },
                    expression: "orgData.name",
                  },
                }),
              ],
              1
            ),
            _c(
              "el-form-item",
              { staticClass: "mySelect", attrs: { label: "省份" } },
              [
                _c(
                  "el-select",
                  {
                    staticStyle: { width: "100px" },
                    attrs: { clearable: "", placeholder: "全部" },
                    on: {
                      change: function ($event) {
                        return _vm.getInsRegistrationView(1)
                      },
                      clear: function () {
                        return (_vm.orgData.raceType = "")
                      },
                    },
                    model: {
                      value: _vm.orgData.provinceId,
                      callback: function ($$v) {
                        _vm.$set(_vm.orgData, "provinceId", $$v)
                      },
                      expression: "orgData.provinceId",
                    },
                  },
                  _vm._l(_vm.provinceData, function (item) {
                    return _c("el-option", {
                      key: item.id,
                      attrs: { label: item.districtName, value: item.id },
                    })
                  }),
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "el-button",
          {
            attrs: { size: "mini", type: "primary" },
            on: {
              click: function ($event) {
                return _vm.getInsRegistrationView(1)
              },
            },
          },
          [_vm._v("查询")]
        ),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "comPractice_container" },
      [
        _c("basic-table", {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          ref: "insRegistrationViewTable",
          attrs: {
            isOperate: false,
            isCheckbox: false,
            tableHeader: _vm.insRegistrationViewHeader,
            tableData: _vm.tableData,
          },
          on: { operation: _vm.operation },
          scopedSlots: _vm._u([
            {
              key: "default",
              fn: function (data) {
                return undefined
              },
            },
          ]),
        }),
        _c("pagination", {
          attrs: { total: _vm.total, limit: _vm.pageSize, page: _vm.pageNum },
          on: {
            "update:limit": function ($event) {
              _vm.pageSize = $event
            },
            "update:page": function ($event) {
              _vm.pageNum = $event
            },
            currentChange: _vm.currentChange,
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }